export class ProductCategoryEndpoints {
    private static readonly BASE = '/api/warehouse/category';

    static list(query: string): string {
        return `${this.BASE}${query}`;
    }

    static get(id: string): string {
        return `${this.BASE}/${id}`;
    }

    static create(): string {
        return this.BASE;
    }

    static update(id: string): string {
        return `${this.BASE}/${id}`;
    }

    static delete(id: string): string {
        return `${this.BASE}/${id}`;
    }

    static activate(id: string): string {
        return `${this.BASE}/${id}/activate`;
    }

    static deactivate(id: string): string {
        return `${this.BASE}/${id}/deactivate`;
    }
}